var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"py-4 d-flex flex-column align-center fill-height"},[_c('router-link',{staticClass:"logo-link-solo mb-3",attrs:{"to":{name: 'Home'}}},[_c('img',{staticClass:"logo-icon",attrs:{"src":require("@/assets/openalex-logo-icon-black-and-white.png")}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }